/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Dms_Restore_Entity_RootInputs */

const cs_api_error_dms_restore_entity_root = /** @type {(inputs: Api_Error_Dms_Restore_Entity_RootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro tuto agendu už existuje aktivní složka. Než obnovíte položku z koše, smažte ji.`)
};

const en_api_error_dms_restore_entity_root = /** @type {(inputs: Api_Error_Dms_Restore_Entity_RootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An active folder already exists for this matter. Delete it before restoring from trash.`)
};

/**
* | output |
* | --- |
* | "An active folder already exists for this matter. Delete it before restoring from trash." |
*
* @param {Api_Error_Dms_Restore_Entity_RootInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const api_error_dms_restore_entity_root = /** @type {((inputs?: Api_Error_Dms_Restore_Entity_RootInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Dms_Restore_Entity_RootInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_dms_restore_entity_root(inputs)
	return cs_api_error_dms_restore_entity_root(inputs)
});